import { ActionType, Action } from "../actions";
interface VideoState {
  camera: string;
  date: string;
  duration: number;
  keywords: string[];
  postcode: string;
  provider: string;
  thumbnail: string[];
  videoURL: string;
  locality: string;
  sensitivity: string;
  _id: string;
}

interface RepoState {
  loading: boolean;
  error: string | null;
  data: VideoState[];
}

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const reducer = (
  state: RepoState = initialState,
  action: Action
): RepoState => {
  switch (action.type) {
    case ActionType.SEARCH_REPOSITORIES:
      return { loading: true, error: null, data: [] };
    case ActionType.SEARCH_REPOSITORIES_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case ActionType.SEARCH_REPOSITORIES_ERROR:
      return { loading: false, error: action.payload, data: [] };
    default:
      return state;
  }
};

export default reducer;
